import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";

const createMultiAutomated = async (formData: any, req: any) => {
  const params = new URLSearchParams(req);
  return axiosInstance
    .post("req/quotes/requestMultipleAutomated", formData, {
      params,
    })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useCreateMultiAutomated = () => {
  return useMutation({
    mutationFn: ({ data, req }: { data: any; req: any }) =>
      createMultiAutomated(data, req),
    mutationKey: ["quote"],
  });
};

export default useCreateMultiAutomated;
